import { gql } from "@apollo/client";

export const SALES_FETCH_CUSTOMERS = gql`
  query SALES_FETCH_CUSTOMERS {
    customers {
      id
      name
      odooPartnerId
      priceList {
        id
        name
        currency
        deletedAt
      }
      archivedAt
    }
  }
`;

export const CREATE_CUSTOMER = gql`
  mutation SALES_CREATE_CUSTOMER(
    $name: String!
    $system: String!
    $currency: String!
    $tags: [String]
    $syncToOdoo: Boolean
  ) {
    salesCreateCustomer(
      name: $name
      system: $system
      currency: $currency
      tags: $tags
      syncToOdoo: $syncToOdoo
    ) {
      customer {
        id
        name
      }
    }
  }
`;

const CUSTOMER_FRAGMENT = gql`
  fragment CustomerFragment on CustomerType {
    id
    name
    odooPartnerId
    system
    notes
    archivedAt
    priceList {
      id
      currency
    }
    shippingZone
    skipCustomerConfirmationForPlan
    requiredCertificateTypes
    user {
      id
      email
    }
    subAccounts {
      id
      user {
        id
        email
      }
    }
    documents {
      id
      uri
    }
  }
`;

export const SALES_FETCH_CUSTOMER = gql`
  query SALES_FETCH_CUSTOMER($id: ID, $odooPartnerId: Int) {
    customer(id: $id, odooPartnerId: $odooPartnerId) {
      ...CustomerFragment
    }
  }
  ${CUSTOMER_FRAGMENT}
`;

export const ARCHIVE_CUSTOMER = gql`
  mutation ARCHIVE_CUSTOMER($id: ID!) {
    archiveCustomer(id: $id) {
      customer {
        id
        archivedAt
      }
    }
  }
`;

export const SALES_SAVE_CUSTOMER = gql`
  mutation SALES_SAVE_CUSTOMER(
    $id: ID!
    $odooPartnerId: Int
    $notes: String
    $priceListId: ID
    $shippingZone: String
    $skipCustomerConfirmationForPlan: Boolean
    $requiredCertificateTypes: String
    $system: String
    $userId: ID
    $newDocumentUris: [String]
    $removeFields: [String]
  ) {
    updateCustomer(
      id: $id
      odooPartnerId: $odooPartnerId
      notes: $notes
      priceListId: $priceListId
      shippingZone: $shippingZone
      skipCustomerConfirmationForPlan: $skipCustomerConfirmationForPlan
      requiredCertificateTypes: $requiredCertificateTypes
      system: $system
      userId: $userId
      newDocumentUris: $newDocumentUris
      removeFields: $removeFields
    ) {
      customer {
        ...CustomerFragment
      }
    }
  }
  ${CUSTOMER_FRAGMENT}
`;

export const SALES_ADD_CUSTOMER_SUB_ACCOUNT = gql`
  mutation SALES_ADD_CUSTOMER_SUB_ACCOUNT($customerId: ID!, $userId: ID!) {
    customerAddSubAccount(customerId: $customerId, userId: $userId) {
      customer {
        id
        subAccounts {
          id
          user {
            id
            email
          }
        }
      }
    }
  }
`;

export const SALES_REMOVE_CUSTOMER_SUB_ACCOUNT = gql`
  mutation CUSTOMER_REMOVE_SUB_ACCOUNT($customerId: ID!, $accountId: ID!) {
    customerRemoveSubAccount(customerId: $customerId, accountId: $accountId) {
      customer {
        id
        subAccounts {
          id
          user {
            id
            email
          }
        }
      }
    }
  }
`;

export const SALES_DELETE_CUSTOMER_DOCUMENT = gql`
  mutation SALES_DELETE_CUSTOMER_DOCUMENT($customerId: ID!, $documentId: ID!) {
    customerRemoveDocument(customerId: $customerId, documentId: $documentId) {
      customer {
        id
        documents {
          id
          uri
        }
      }
    }
  }
`;

export const FETCH_ODOO_CUSTOMER_TAGS = gql`
  query FETCH_ODOO_CUSTOMER_TAGS {
    odooCustomerTags
  }
`;
